import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BarChart3, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

const MOOD_COLOR = { great: "bg-accent", good: "bg-sage", okay: "bg-secondary", low: "bg-muted", struggling: "bg-card" };

export default function WeeklyReportPage() {
  const [data, setData] = useState(null);
  const [gated, setGated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { const r = await api.get("/premium/weekly-report"); setData(r.data); }
      catch (e) { if (e.response?.status === 402) setGated(true); }
      finally { setLoading(false); }
    })();
  }, []);

  if (loading) return <div className="brutal-card bg-card p-5">Generating your reflection…</div>;
  if (gated) {
    return (
      <div className="brutal-card bg-accent p-8 text-center" data-testid="report-gate">
        <Sparkles size={28} strokeWidth={2.5} className="mx-auto mb-2" />
        <h2 className="text-3xl">Weekly reports are part of HAEVEN Calm</h2>
        <Link to="/premium" className="brutal-btn bg-primary text-primary-foreground inline-block mt-5 px-5 py-2" data-testid="upgrade-btn">See plans</Link>
      </div>
    );
  }

  return (
    <div data-testid="weekly-report-page">
      <div className="flex items-center gap-2 mb-3"><BarChart3 size={26} strokeWidth={2.5} /> <h1 className="text-4xl">Your week</h1></div>

      <div className="brutal-card bg-accent p-6 mb-6">
        <div className="flex items-center gap-2 mb-2"><Sparkles size={18} strokeWidth={2.5} /> <h3 className="text-xl font-display">Care AI reflection</h3></div>
        <p className="leading-relaxed">{data?.summary}</p>
      </div>

      <h3 className="text-2xl mb-3">Moods</h3>
      {data?.moods?.length ? (
        <div className="flex flex-wrap gap-2 mb-6">
          {data.moods.map((m) => (
            <div key={m.id} className={`brutal-card px-3 py-2 text-xs ${MOOD_COLOR[m.mood] || "bg-card"}`}>
              {m.mood} · {new Date(m.created_at).toLocaleDateString()}
            </div>
          ))}
        </div>
      ) : <p className="text-sm text-muted-foreground mb-6">No moods logged this week.</p>}

      <h3 className="text-2xl mb-3">Journal snippets</h3>
      {data?.journals?.length ? (
        <div className="space-y-3">
          {data.journals.map((j) => (
            <div key={j.id} className="brutal-card bg-card p-4">
              <div className="text-xs text-muted-foreground mb-1">{new Date(j.created_at).toLocaleDateString()} {j.mood && `· ${j.mood}`}</div>
              <p className="whitespace-pre-wrap text-sm">{j.content}</p>
            </div>
          ))}
        </div>
      ) : <p className="text-sm text-muted-foreground">No journal entries this week.</p>}
    </div>
  );
}
